























import { defineComponent, ref, computed } from "@vue/composition-api";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { getCountryName, getStateName } from "@/lib/i18nHelpers";
import { FormValue, ListField } from "@/types";
import BaseCheckChip from "@/components/BaseCheckChip";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";
import LocationSearchInput from "@/components/LocationSearchInput";
import { languageList } from "@/views/PagePayeeInfo/config";

export default defineComponent({
  name: "PersonalLocalization",
  components: {
    LocationSearchInput,
    BaseCheckChip,
    CustomScroll,
    BaseInput,
  },
  setup(_, { emit }) {
    const { authUser } = useAuthUser();
    const location = ref<FormValue>("");
    const personalLocalization = ref<FormValue>({
      localizationCity: "",
      localizationStateCode: "",
      localizationCountryCode: "",
      localizationLanguage: [],
    });
    const show = ref(false);
    const showClear = ref(false);

    const checkedLanguages = computed<Record<string, boolean>>(() => {
      if (
        personalLocalization.value &&
        personalLocalization.value.localizationLanguage &&
        personalLocalization.value.localizationLanguage.length
      )
        showClear.value = true;
      else showClear.value = false;
      return languageList.reduce<Record<string, boolean>>((out, item) => {
        out[item.text] = personalLocalization.value
          ? !!personalLocalization.value.localizationLanguage?.includes(item.value)
          : false;
        return out;
      }, {});
    });

    const saveFields = () => {
      if (!authUser.value) return;
      providers.UserPublicDataProvider.userPublicInformationUpdate({
        userId: authUser.value.id,
        location: {
          countryCode: personalLocalization.value.localizationCountryCode,
          stateCode: personalLocalization.value.localizationStateCode || "",
          city: personalLocalization.value.localizationCity || "",
        },
        languages: personalLocalization.value.localizationLanguage,
      });
    };

    const setLocation = (value: BlockedLocationAutocomplete) => {
      personalLocalization.value.localizationCity = value.city;
      personalLocalization.value.localizationStateCode = value.stateCode;
      personalLocalization.value.localizationCountryCode = value.countryCode;
      emit("setValid", true);
    };

    const getData = async () => {
      if (!authUser.value) return;
      const response = await providers.UserPublicDataProvider.userPublicInformationFind(authUser.value.id);
      if (response.location.countryCode) {
        location.value += getCountryName(response.location.countryCode);
        emit("setValid", true);
      }

      if (response.location.stateCode && response.location.countryCode) {
        location.value += `, ${getStateName(response.location.stateCode, response.location.countryCode)}`;
      }

      if (response.location.city) {
        location.value += `, ${response.location.city}`;
      }
      personalLocalization.value.localizationCity = response.location.city;
      personalLocalization.value.localizationStateCode = response.location.stateCode;
      personalLocalization.value.localizationCountryCode = response.location.countryCode;
      personalLocalization.value.localizationLanguage = response.languages || [];
    };

    const input = (field: ListField, value: boolean) => {
      if (value) {
        personalLocalization.value.localizationLanguage.push(field.value);
      } else {
        personalLocalization.value.localizationLanguage = personalLocalization.value.localizationLanguage.filter(
          (i: string) => i !== field.value
        );
      }
    };

    const created = async () => {
      emit("setValid", false);
      emit("setCb", () => saveFields());
      try {
        emit("setLoading", true);
        await getData();
      } finally {
        emit("setLoading", false);
      }
    };

    created();

    return {
      show,
      showClear,
      location,
      checkedLanguages,
      languageList,
      setLocation,
      input,
    };
  },
});
